import { datadogLogs } from "@datadog/browser-logs";
import { isProd } from "../isProd";

/**
 * A failed API response. The response body is deliberately left out: it can
 * carry customer data, and the log context is sent unmasked.
 */
export class ApiError extends Error {
  // Datadog groups by message by default; ours contains ids, so pin the grouping.
  // computeRawError reads `dd_fingerprint` off the error object.
  readonly dd_fingerprint: string;

  constructor(
    readonly method: string,
    readonly url: string,
    readonly status: number,
  ) {
    super(`${method} ${url} failed with status ${status}`);
    this.name = "ApiError";
    this.dd_fingerprint = `api-error-${status}`;
    this.stack = `${this.name}: ${this.message}`;
  }

  /** Attached to the error log, searchable as `@api.*`. */
  get logContext() {
    return {
      api: { method: this.method, url: this.url, status: this.status },
    };
  }
}

export const reportApiError = (error: Error, context?: object) => {
  if (!isProd) {
    return;
  }

  datadogLogs.logger.error(error.message, context, error);
};
